export default "__VITE_ASSET__DBIxQ0Zw__"